import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';

function Login() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.login(formData);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-container" style={{display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh'}}>
      <div className="auth-container">
        <div style={{textAlign: 'center', marginBottom: '24px'}}>
          <img
            src="/logo.svg"
            alt="Payroll Shift Schedule Organizer"
            style={{
              width: '100px',
              height: '100px',
              margin: '0 auto 16px',
              display: 'block',
              filter: 'drop-shadow(0 4px 20px rgba(5, 150, 105, 0.3))'
            }}
          />
        </div>
        <h2 style={{ fontSize: '1.6em' }}>Payroll Shift Schedule Organizer</h2>
        <p className="auth-subtitle">Welcome back! Sign in to continue.</p>

        {error && <div className="error-message">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-control"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              className="form-control"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%', padding: '16px', fontSize: '1em' }} disabled={loading}>
            {loading ? (
              <span style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px'}}>
                <span style={{
                  width: '18px',
                  height: '18px',
                  border: '2px solid rgba(255,255,255,0.3)',
                  borderTopColor: 'white',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite'
                }}></span>
                Signing in...
              </span>
            ) : (
              <span>Sign In</span>
            )}
          </button>
        </form>

        <div style={{
          marginTop: '32px',
          paddingTop: '24px',
          borderTop: '1px solid rgba(5, 150, 105, 0.2)',
          textAlign: 'center',
          fontSize: '0.85em',
          color: 'var(--text-secondary)'
        }}>
          <p style={{marginBottom: '8px'}}>Intelligent Shift Management</p>
          <div style={{display: 'flex', justifyContent: 'center', gap: '16px', opacity: 0.6}}>
            <span>Secure</span>
            <span>Fast</span>
            <span>Reliable</span>
          </div>
        </div>

        <footer style={{
          marginTop: '24px',
          paddingTop: '16px',
          borderTop: '1px solid rgba(5, 150, 105, 0.1)',
          textAlign: 'center',
          fontSize: '0.75em',
          color: 'var(--text-secondary)',
          opacity: 0.7
        }}>
          <p style={{margin: '0 0 4px 0'}}>Created by Patricia Louise</p>
          <p style={{margin: '0 0 4px 0'}}>Payroll Shift Schedule Organizer &copy; {new Date().getFullYear()}</p>
          <p style={{margin: 0}}>All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}

export default Login;
